module.exports = __webpack_public_path__ + "static/media/arrow-from-top.89db45e3.svg";